// Wave TW-1.f.6 (2026-05-24) — 인보이스 상단 거래 완료 확인 패널 (내부 사용자)
//
// API:
//   POST /api/transactions/by-cars { carIds: int[] } → { items: tx_confirm[] }
//   POST /api/transactions/:id/confirm
//
// 동작:
//   - props.carIds 변경 시 POST by-cars fetch
//   - 매칭된 tx_confirm 행마다 카드 노출 (count > 0 시 영역 표시)
//   - 각 카드: source 라벨 + 상태 뱃지 + 확인 버튼 (본인 측 미확인 시만 활성)
//   - confirm 후 패널 재로드

import React, { useState, useEffect, useCallback } from 'react';
import { API, authFetch } from '../utils/api';

function InvoiceTxConfirmPanel(props) {
  var carIds = (props.carIds || []).filter(function (x) { return x > 0; });
  var showToast = props.showToast || function () {};
  var [items, setItems] = useState([]);
  var [busyId, setBusyId] = useState(0);

  // carIds 변경 감지 — 안정적 key 로 string join (deps array 가 array 자체 비교 시 매 렌더 트리거)
  var key = carIds.slice().sort(function (a, b) { return a - b; }).join(',');

  var load = useCallback(function () {
    if (!key) { setItems([]); return; }
    authFetch(API + '/transactions/by-cars', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ carIds: key.split(',').map(function (x) { return parseInt(x, 10); }) }),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success && d.data) setItems(d.data.items || []); })
      .catch(function () { /* silent */ });
  }, [key]);

  useEffect(function () { load(); }, [load]);

  var onConfirm = function (row) {
    if (busyId === row.id) return;
    if (!window.confirm('거래 완료를 확인하시겠습니까?')) return;
    setBusyId(row.id);
    authFetch(API + '/transactions/' + row.id + '/confirm', { method: 'POST' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        setBusyId(0);
        if (d && d.success) {
          showToast(d.completed ? '양측 확인 완료 — 거래 종료' : '거래 완료 확인 — 상대방 확인 대기', 'success');
          load();
        } else {
          showToast((d && d.error) || '확인 실패', 'error');
        }
      })
      .catch(function () {
        setBusyId(0);
        showToast('네트워크 오류', 'error');
      });
  };

  if (items.length === 0) return null;

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 6 }}>
        📋 거래 완료 확인 ({items.length}건)
      </div>
      {items.map(function (row) {
        var sourceLabel = row.source_type === 'rfq' ? '사전조회' : '경매';
        var sellerConfirmed = !!row.seller_confirmed_at;
        var buyerConfirmed = !!row.buyer_confirmed_at;
        return (
          <div key={row.id}
            style={{
              background: row.completed_at ? '#f0fdf4' : '#eff6ff',
              border: '1px solid ' + (row.completed_at ? '#86efac' : '#bfdbfe'),
              borderRadius: 8, padding: '10px 12px', marginBottom: 6,
            }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#1B3A5C' }}>
                {sourceLabel} #{row.source_id}
                {row.amount ? ' · ' + Number(row.amount).toLocaleString() + '원' : ''}
              </span>
              {row.reminder_count > 0 && (
                <span style={{ fontSize: 9, color: '#b45309', background: '#fef3c7', padding: '1px 6px', borderRadius: 4, fontWeight: 600 }}>
                  재알림 {row.reminder_count}회
                </span>
              )}
            </div>
            <div style={{ display: 'flex', gap: 10, fontSize: 10, color: '#475569', marginBottom: 6 }}>
              <span style={{ color: sellerConfirmed ? '#15803d' : '#94a3b8' }}>
                {sellerConfirmed ? '✓ 출품자' : '⏳ 출품자'}
              </span>
              <span style={{ color: buyerConfirmed ? '#15803d' : '#94a3b8' }}>
                {buyerConfirmed ? '✓ 바이어' : '⏳ 바이어'}
              </span>
            </div>
            {row.completed_at ? (
              <div style={{ fontSize: 11, fontWeight: 700, color: '#16a34a' }}>✅ 양측 확인 완료</div>
            ) : (
              <button type="button" onClick={function () { onConfirm(row); }}
                disabled={sellerConfirmed || busyId === row.id}
                style={{
                  padding: '5px 12px',
                  background: sellerConfirmed ? '#e2e8f0' : '#1B3A5C',
                  color: sellerConfirmed ? '#64748b' : 'white',
                  border: 'none', borderRadius: 6,
                  fontSize: 11, fontWeight: 700,
                  cursor: sellerConfirmed ? 'default' : 'pointer',
                }}>
                {sellerConfirmed ? '확인 완료' : (busyId === row.id ? '처리 중…' : '거래 완료 확인')}
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default InvoiceTxConfirmPanel;
